import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

// Show success alert
export const showSuccessAlert = (message: string) => {
  MySwal.fire({
    title: "Success!",
    text: message,
    icon: "success",
    confirmButtonColor: "#3085d6",
    confirmButtonText: "OK",
  });
};

// Show error alert
export const showErrorAlert = (message: string) => {
  MySwal.fire({
    title: "Error!",
    text: message,
    icon: "error",
    confirmButtonColor: "#3085d6",
    confirmButtonText: "OK",
  });
};

// Show warning alert
export const showWarningAlert = (message: string) => {
  MySwal.fire({
    title: "Warning!",
    text: message,
    icon: "warning",
    confirmButtonColor: "#3085d6",
    confirmButtonText: "OK",
  });
};

// Show info alert
export const showInfoAlert = (message: string) => {
  MySwal.fire({
    title: "Info",
    text: message,
    icon: "info",
    confirmButtonColor: "#3085d6",
    confirmButtonText: "OK",
  });
};

// Show confirmation alert for delete actions
export const showDeleteConfirmationAlert = (
  title: string = "Are you sure?",
  text: string = "You won't be able to revert this!",
  confirmButtonText: string = "Yes, delete it!",
  cancelButtonText: string = "Cancel"
) => {
  return MySwal.fire({
    title: title,
    text: text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#824EEB",
    cancelButtonColor: "#ff0000",
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText,
  });
};

// Show basic alert
export const showBasicAlert = (message: string) => {
  MySwal.fire({
    text: message,
    confirmButtonText: "OK",
  });
}; 